<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main" id="page-content-main">
    <epay-lib-employer-register [baseurl]="baseurl" [termsContent]="termsContent" [loginHelp]="loginHelp"
      [canCreateNewEmployer]="canCreateNewEmployer" [useEmailForLogin]="useEmailForLogin" [allowEINSearch]="allowEINSearch">
    </epay-lib-employer-register>
  </div>
</epay-page-content>
